import { render, staticRenderFns } from "./WindControlHome_Admin.vue?vue&type=template&id=63fb4300&"
import script from "./WindControlHome_Admin.vue?vue&type=script&lang=js&"
export * from "./WindControlHome_Admin.vue?vue&type=script&lang=js&"
import style0 from "./WindControlHome_Admin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports